import _classCallCheck from "/workspace/src/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/workspace/src/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

function getHourAsDate(hour) {
  return new Date(2017, 10, 0, hour, 0, 0);
}

var HourSpan = /*#__PURE__*/function () {
  function HourSpan(minHour, maxHour) {
    _classCallCheck(this, HourSpan);

    this.minHour = minHour;
    this.maxHour = maxHour;
  }

  _createClass(HourSpan, [{
    key: "getMinHourAsDate",
    value: function getMinHourAsDate() {
      return getHourAsDate(this.minHour);
    }
  }, {
    key: "getMaxHourAsDate",
    value: function getMaxHourAsDate() {
      return getHourAsDate(this.maxHour);
    }
  }]);

  return HourSpan;
}();

export { HourSpan as default };